import { Alert } from 'app/models/dto/alert.model';
import { Document } from 'app/models/dto/document.model';

export class SendToOcrolus {
    static readonly type = '[Ocrolus] SendToOcrolus';
    constructor(
        public borrowerId: number,
        public docIds: number[],
        public append: boolean
    ) {}
}
export class GetOcrolusActivity {
    static readonly type = '[Ocrolus] GetOcrolusActivity';
    constructor(
        public borrowerId: number,
        public documents: Document[]
    ) {}
}

export class SetOcrolusAlert {
    static readonly type = '[Alert] SetOcrolusAlert';
    constructor(public alert: Alert) {}
}

export class DismissOcrolusAlert {
    static readonly type = '[Alert] DismissOcrolusAlert';
    constructor(public borrowerId: number) {}
}
